import { useEffect, useState, type CSSProperties, type ReactNode } from 'react';
import { useLayout } from '../lib/layout';

/** Phone width the mockup was drawn at. */
export const MOCK_W = 390;

/** Current column width: the phone (at most 480 px), or the side panel on a tablet or desktop. */
export function useColumnWidth(): number {
  const L = useLayout();
  const read = () => Math.min(typeof window === 'undefined' ? MOCK_W : window.innerWidth, 480);
  const [w, setW] = useState(read);
  useEffect(() => {
    const on = () => setW(read());
    window.addEventListener('resize', on);
    return () => window.removeEventListener('resize', on);
  }, []);
  return L.wide ? L.panelW : w;
}

/**
 * A 390-wide piece of the mockup (illustration plus the labels and pictures placed on it) scaled to the phone's
 * width, so everything on it stays where the mockup put it.
 */
export function Stage({ height, top, bottom, children, style }: { height: number; top?: number | string; bottom?: number | string; children: ReactNode; style?: CSSProperties }) {
  const w = useColumnWidth();
  const k = w / MOCK_W;
  return (
    <div
      aria-hidden="true"
      style={{
        position: 'absolute',
        left: '50%',
        top,
        bottom,
        width: MOCK_W,
        height,
        marginLeft: -MOCK_W / 2,
        transform: `scale(${k})`,
        transformOrigin: bottom !== undefined ? 'bottom center' : 'top center',
        pointerEvents: 'none',
        ...style,
      }}
    >
      {children}
    </div>
  );
}
